import { render, staticRenderFns } from "./viewoff.vue?vue&type=template&id=823ba31e"
import script from "./viewoff.vue?vue&type=script&lang=js"
export * from "./viewoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports